export const constants = {
  ECOM_CART: "shop-cart",
  ECOM_ORDER_HISTORY: "shop-order-history",
  PAYMENT_METHOD_SEPA: "sepa",
  PAYMENT_METHOD_BANK_CARD: "bank_card",
  PARAM_PLUS: "shop-param-plus",
  URL_PARAMS: "shop-url-params",
  AUTHORIZATION_STATUS_TIMEOUT: 1000 * 60 * 3, // 3 minutes
  CONFIRMATION_OFFER_WINDOW_MS: 1000 * 60 * 30, // 30 minutes
  ECOM_SESSION: "shop-session",
  CONFIG_GRAPES: "config-grapes",
  // Survives checkout → /waiting full-page reload (Pinia is recreated).
  ORDER_PAGE_COREG_SELECTION: "order-page-coreg-selection",
  HAS_1_CLICK_OPTOUT: "has-1-click-optout",
  SELECTED_CHOICES_TYPE: "selected-choices-type",
  DEFAULT_CHOICES_MODE: "default",
  ALTERNATIVE_CHOICES_MODE: "alternative",
  UPSELLED: "upselled",
  LOCAL_STORAGE_GC: "local-storage-gc",
  ECOM_COUPONS: "shop-coupons",
  INITIAL_ORDER_DATA: "shop-initial-order-data",
  COUPON_TTL: 1000 * 60 * 60 * 24, // 1 day
  // FORGE-308: query string params de preview/test à ne pas propager dans le
  // flow paiement (PARAM_PLUS / localStorage). Centralisé pour rester aligné
  // entre le flow process-order (cross-sell/upsell) et le flow one-click.
  IGNORED_PARAM_PLUS_KEYS: [
    "testLevel",
    "step",
    "parentChoiceId",
    "previewMode",
    "retry",
  ],
};
